import { useState } from "react";
import { useNavigate } from "react-router-dom";

import Carousel from "../../components/Carousel";
import ContentWrapper from "../../components/ContentWrapper";
import SwitchTabs from "../SwitchTabs";
import useFetch from "../../hooks/useFetch";
import "./style.scss";

const Trending = () => {
  const currency = process.env.REACT_APP_CURRENCY;

  const [endpoint, setEndpoint] = useState(`/eventspercurrency/${currency}`);

  const { data, loading } = useFetch(endpoint);

  const onTabChange = (tab: string) => {
    setEndpoint(
      tab === "This Week"
        ? `/eventspercurrency/${currency}`
        : `/eventspercurrency/${currency}`
    );
  };

  return (
    <div className="carouselSection">
      <ContentWrapper>
        <span className="carouselTitle ">Trending</span>
        <SwitchTabs
          data={["This Week", "This Month"]}
          onTabChange={onTabChange}
        />
      </ContentWrapper>

      <Carousel data={data?.data} loading={loading} />
    </div>
  );
};

export default Trending;
